import React, { Component } from "react";
import "./DegreeCard.css";
import "../button/Button.css";
import { Fade, Flip } from "react-reveal";
import { withTranslation } from "react-i18next";

class DegreeCard extends Component {
  render() {
    const degree = this.props.degree;
    const theme = this.props.theme;
    const { t } = this.props;
    return (
      <div className="degree-card">
        {degree.logo_path && (
          <Flip left duration={1000}>
            <div className="card-img">
              <img
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  transform: "scale(1.0)",
                }}
                src={require(`../../assets/images/${degree.logo_path}`)}
                alt={degree.alt_name}
              />
            </div>
          </Flip>
        )}
        <Fade right duration={800} distance="20px">
          <div
            className="card-body"
            style={{ width: degree.logo_path ? "90%" : "100%" }}
          >
            <div
              className="body-header"
              style={{ backgroundColor: degree.headerColor || theme.headerColor }}
            >
              <div className="body-header-title">
                <h2 className="card-title" style={{ color: theme.text }}>
                  {degree.title}
                </h2>
                <h3 className="card-subtitle" style={{ color: theme.text }}>
                  {degree.subtitle}
                </h3>
              </div>
              <div className="body-header-duration">
                <h3 className="duration" style={{ color: theme.text }}>
                  {degree.duration}
                </h3>
              </div>
            </div>
            <div className="body-content">
              {degree.descriptions.map((sentence) => {
                return (
                  <p className="content-list" style={{ color: theme.text }}>
                    {sentence}
                  </p>
                );
              })}
              {degree.website_link && (
                <a
                  href={degree.website_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="main-button visit-btn-link"
                  style={{
                    color: theme.buttonText || theme.body,
                    backgroundColor: theme.buttonPrimary || theme.text,
                    border: `solid 1px ${theme.buttonPrimary || theme.text}`,
                    "--btn-text": theme.buttonPrimary || theme.text,
                    "--btn-bg": theme.body,
                  }}
                >
                  {t("buttons.visitWebsite")}
                </a>
              )}
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}

export default withTranslation()(DegreeCard);
